import { BaseModel, ID } from '@models/base'

import { PatientPreviewModel } from './patientPreview'
import { ProductUnitModel } from './productUnit'
import { QueueNumberModel } from './queueNumber'
import { SalesInvoiceModel } from './salesInvoice'
import { UnitModel } from './unit'

enum CartItemCategoryEnum {
  DOCTOR_FEE = 'DOCTOR_FEE',
  PHARMACY = 'PHARMACY',
  ADMIN_FEE = 'ADMIN_FEE',
  LABORATORY = 'LABORATORY',
  RETAIL = 'RETAIL',
  BUNDLING = 'BUNDLING',
  REPRINT_FEE_MEDICAL_CERTIFICATE = 'REPRINT_FEE_MEDICAL_CERTIFICATE',
  REPRINT_FEE_DOCTOR_REFERRAL = 'REPRINT_FEE_DOCTOR_REFERRAL',
  REPRINT_FEE_DOCTOR_MEMO = 'REPRINT_FEE_DOCTOR_MEMO',
  REPRINT_FEE_PRESCRIPTION = 'REPRINT_FEE_PRESCRIPTION',
  REPRINT_FEE_HEALTH_EXAMINATION_RESULT = 'REPRINT_FEE_HEALTH_EXAMINATION_RESULT',
  REPRINT_FEE_MEDICAL_SUMMARY = 'REPRINT_FEE_MEDICAL_SUMMARY',
  MIXED_MEDICINE_FEE = 'MIXED_MEDICINE_FEE',
}

enum CartTypeEnum {
  MEDICAL = 'MEDICAL',
  RETAIL = 'RETAIL',
}

type CartItemModel = BaseModel & {
  category: CartItemCategoryEnum
  image_link: string | null
  initial_qty: number | null
  item_name: string
  price: number | null
  price_before_discount: number | null
  product_unit: ProductUnitModel | null
  qty: number
  subtotal: number | null
  unit: UnitModel | null
  view_category: CartItemCategoryEnum
}

type CartModel = BaseModel & {
  cart_items: Array<CartItemModel>
  clinic_id: ID
  is_active: boolean
  name: string | null
  patient: PatientPreviewModel | null
  patient_id: ID
  queue_number: QueueNumberModel | null
  sales_invoice: SalesInvoiceModel | null
  type: CartTypeEnum
}

export type { CartModel, CartItemModel }

export { CartTypeEnum, CartItemCategoryEnum }
